import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

function DocumentRenameComponentAssemble({ initialDocumentName }) {
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    if (initialDocumentName) {
      setDisplayName(initialDocumentName);
    }
  }, [initialDocumentName]);
  const [containerHeight, setContainerHeight] = useState(21);
  const textRef = useRef(null);
  const LINE_HEIGHT = 21;
  const MAX_HEIGHT = 84;

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const scrollHeight = element.scrollHeight;
      const numberOfLines = Math.ceil(scrollHeight / LINE_HEIGHT);
      const newHeight = Math.min(numberOfLines * LINE_HEIGHT, MAX_HEIGHT);
      setContainerHeight(newHeight);
    }
  }, [displayName]);

  return (
    <>
      <div
        className="tile-row mw-100 flex-wrap d-flex align-items-center p-l-5 p-r-5"
        style={{
          height: `${containerHeight}px`,
          minHeight: "21px",
          maxHeight: `${MAX_HEIGHT}px`,
          transition: "height 0.1s ease",
          overflow: "hidden",
          background: "var(--primary-2)",
          fontWeight: "600",
        }}
      >
        <span
          ref={textRef}
          className="text-black text-start text-break font-weight-semibold d-block"
        >
          {/* {displayName.length > 50
            ? `${displayName.slice(0, 50)}...`
            : displayName} */}
          {displayName}
        </span>
      </div>
    </>
  );
}

DocumentRenameComponentAssemble.propTypes = {
  initialDocumentName: PropTypes.string,
};

DocumentRenameComponentAssemble.defaultProps = {
  initialDocumentName: "",
};
export default DocumentRenameComponentAssemble;
